<template>
    <span v-if="mostrarBtnAtualizarDespViagem" class="ml-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Ajustar despesa de viagem"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">
                Contratação - Ajustar Valor Desp. Viagem
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Despesa de viagem</label><br />
                        <span
                            ><strong>{{ despViagem.nome }}</strong></span
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Valor atual</label>
                        <money
                            v-model="valorAtual"
                            v-bind="money"
                            class="form-control text-right"
                            :disabled="true"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valorAjustado.$error ? false : null"
                        invalid-feedback="Valor deve ser maior que 0"
                    >
                        <label>Valor ajustado</label>
                        <money
                            v-model="valorAjustado"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valorAjustado.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarAtualizarDespViagem()"
                    >Ajustar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        despViagem: {
            type: Object,
            default: () => ({})
        },

        contratacoesServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            valorAtual: 0,
            valorAjustado: 0,
            justificativa: '',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
            this.valorAtual = this.despViagem.valorDespViagem
        },

        fecharModal() {
            this.mostrarModal = false
            this.reset()
        },

        reset() {
            this.valorAtual = 0
            this.valorAjustado = 0
            this.justificativa = ''
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        confirmarAtualizarDespViagem() {
            this.$swal({
                title: 'Ajustar Despesa de Viagem',
                html: `Confirma o ajuste da despesa de viagem ${this.despViagem.nome} da contratação ${this.despViagem.codContratacao}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.atualizarDespViagem()
                }
            })
        },

        atualizarDespViagem() {
            this.$store.dispatch('addRequest')
            let despViagemAtualizadaDto = {
                codContratacao: this.despViagem.codContratacao,
                tipo: this.despViagem.nome == 'CONSULTORIA' ? 0 : 1,
                valor: this.valorAjustado,
                justificativa: this.justificativa
            }
            this.contratacoesServicos
                .atualizarDespViagem(despViagemAtualizadaDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAtualizacao')
                            this.fecharModal()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnAtualizarDespViagem() {
            return (
                this.$temAcesso('CRED-UABS-CONT-03') &&
                !this.despViagem.pagamento &&
                this.despViagem.valorDespViagem > 0 &&
                !this.despViagem.cancelada
            )
        }
    },

    validations: {
        valorAjustado: {
            required,
            minValue: minValue(0.01)
        },
        justificativa: {
            required
        }
    }
}
</script>
